import { Button, Text } from '@viapeople/components'
import { useEffect } from 'react'
import { useLogout } from '../modules/login/useAuth'
import { maintenanceStore } from '../sharedStores/maintenanceStore'
import { AppHeader } from './AppHeader'

export const MaintenanceScreen = () => {
	const { message, isChecking, checkMaintenanceStatus, startPolling, stopPolling } = maintenanceStore()
	const { logout } = useLogout()

	useEffect(() => {
		startPolling()
		return () => stopPolling()
	}, [startPolling, stopPolling])

	const handleLogout = () => {
		logout.mutate()
	}

	return (
		<div className='flex h-screen flex-col bg-neutral-800'>
			{/* Keep header visible */}
			<AppHeader />

			{/* Maintenance message - centered on dark background */}
			<div className='flex-1 flex items-center justify-center'>
				<div className='text-center max-w-lg p-8'>
					<Text variant='h3' weight='semibold' className='text-white mb-6'>
						Under Maintenance
					</Text>
					<Text variant='medium' className='text-white mb-8'>
						{message ||
							'ViaPeople is currently down for maintenance. This should be resolved very shortly. Please reach out to support@viapeople.com if you have any questions.'}
					</Text>
					<div className='flex gap-3 justify-center'>
						<Button variant='primary' onClick={checkMaintenanceStatus} isLoading={isChecking}>
							Check Again
						</Button>
						<Button variant='secondary' onClick={handleLogout} isLoading={logout.isPending}>
							Logout
						</Button>
					</div>
				</div>
			</div>
		</div>
	)
}
